<template>
  <div style="background: white">
    <dss-card class="index-model-3" style="margin-top: 80px;" :wrap-width="wrapWidth" title="核心价值">
      <div class="wrapper">
        <div class="wrapperLeft">
          <div style="width: 200px" class="ml-12 mb-4">
            <div>针对3000余家三级医院</div>
            <div>支持SAAS和私有化部署</div>
          </div>

          <div class="leftText">
            临床科研
          </div>
          <v-img :src="coreLeft" max-width="400px"></v-img>
          <div class="ml-6 mt-4">托管式科研服务</div>
        </div>
        <div class="wrapperCenter">科研成果</div>
        <div class="wrapperRight">
          <div class="ml-12 mb-4">
            <div>医疗药械配套软件</div>
            <div> 数字疗法（药械）</div>
            <div>临床科研辅助系统（CDSS）</div>
          </div>
          <div class="leftText">
            成果转化
          </div>
          <div class="rightText">
            患者收益
          </div>
          <v-img :src="coreRight" max-width="350px"></v-img>
          <div class="mt-4">标准化院内院外病程服务</div>
        </div>
      </div>
      <div class="d-flex justify-center align-center" style="width: 100%">
        <ul style="width: 80%;color: #878FA7;" class="d-flex justify-space-between align-center">
          <template v-for="text in footData">
            <li :key="text">{{text}}</li>
          </template>
        </ul>
      </div>
    </dss-card>
  </div>
</template>
<script>

import DssCard from '../dss/dss-card.vue'
import coreLeft from '../../../../assets/pc/index/smart/core-left.png'
import coreRight from '../../../../assets/pc/index/smart/core-right.png'
export default {
  name: 'coreTechnology',
  components: {DssCard},
  data: () => {
    return {
      coreLeft: coreLeft,
      coreRight: coreRight,
      footData: [
        '积累前期研究基础',
        '降低科研门槛',
        '提升科研效率',
        '提高成果转化率'
      ]
    }
  },
  props: {
    wrapWidth: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 600px;
}
.wrapperLeft {
  //width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.wrapperCenter {
  //width: 10%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-top: 3%;
}
.wrapperRight {
  //width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.leftText{
  position: absolute;
  top: 52%;
  font-size: 18px;
  font-weight: bold;
}
.rightText {
  position: absolute;
  top: 52%;
  right: -10%;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/prodCore/core-value.vue